import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-3 py-4" }

import { ref } from "vue";
import { useRouter } from "vue-router";
import Header from "@/components/organisms/common/Header.vue";
import TextFieldGroup from "@/components/molecules/form/TextFieldGroup.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { accountService } from "@/app/services/AccountService";
import { useLoader } from "@/utils/loader";
import { useErrorModal, useModal } from "@/utils/modal";


export default /*#__PURE__*/_defineComponent({
  __name: 'Registration',
  setup(__props) {

// NOTE: 現状このページへの導線は存在しなくなっているものの、今後追加予定とのこと
const router = useRouter();
const loader = useLoader();
const errorModal = useErrorModal();
const modal = useModal();

const code = ref("");

function onClickBack() {
  router.back();
}
async function applyCode() {
  loader.show();
  try {
    await accountService.applyReferPromotionCode({ code: code.value });
    await showSuccessModal();
    onClickBack();
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
}
async function showSuccessModal() {
  await modal.msgBoxOk("招待キャンペーンコードの登録が完了しました。", {
    okVariant: "success",
    centered: true
  });
}

return (_ctx: any,_cache: any) => {
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      招待コード登録\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CustomValidationObserver, { ref: "vObserver" }, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_ValidationProvider, {
            name: "招待コード",
            rules: { required: true, length: 8 },
            vid: "code"
          }, {
            default: _withCtx((validationState) => [
              _createVNode(TextFieldGroup, {
                modelValue: code.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event)),
                label: "招待コード",
                appLabelText: "必須",
                placeholder: "",
                validationState: validationState,
                class: "mt-3"
              }, null, 8, ["modelValue", "validationState"])
            ]),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(AppButton, {
            block: true,
            class: "mt-4",
            variant: 'success',
            onClick: ($event: any) => (handleSubmit(applyCode))
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n          登録する\n        ")
            ], undefined, true),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 512)
    ])
  ]))
}
}

})